import { useCallback, useEffect, useState } from "react"






export const useDebounce = (delay=300)=>{

    const [debounce,setDebounce] = useState<null|{key_trigger:string,values:any,helper?:{index:number}}>()

   const handlDebounce= useCallback((value:{key_trigger:string,values:any,helper?:{index:number}})=>{
        const timer = setTimeout(()=>setDebounce(value),delay)
        return ()=>clearTimeout(timer)
    },[delay])

    return {debounce,handlDebounce}
}